<template>
  <div
    class="e-card-actions"
    :style="_style "
  >
    <SogFlexRow :style="_styleRow">
      <slot />
    </SogFlexRow>
  </div>
</template>

<script setup lang="ts">
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import {computed} from "vue";
import {ref} from "vue";

interface Props {
  isToolbar?: boolean
  withBadge?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    isToolbar: false, withBadge: false
  }
)


const _style = computed(() => {
  const result = ref("")
  //const result = ref("background-color: red;")
  if (props.isToolbar) {
    result.value += "padding-top: 0; padding-bottom:12px;"
  }
  return result.value
  //return "" + (props.isToolbar ? "padding-top: 0; padding-bottom:0;background-color: red; " : "");
})

const _styleRow = computed(() => {
  const result = ref("justify-content: flex-start;padding-bottom: 3px;padding-left: 3px;")
  if (props.withBadge) {
    result.value += "height:44px;"
  }
  return result.value;
  //return "" + (props.isToolbar ? "padding-top: 0; padding-bottom:0;background-color: red; " : "");
})


</script>

<style scoped>
</style>
